import {
  FSP_CORE_CONFIG_LABEL,
  FSP_CONFIG_PAY_A_LOAN_LABEL,
  FSP_CONFIG_VALUES_LABEL,
  FSP_LABEL,
  LIMITS,
  OTP_EVENT_LABEL,
  PAYNETS_LABEL,
  ROUTING_NUMBERS_LABEL,
  SSO_URI_LABEL,
  USER_ROLES,
} from 'consts';
import { IMPORT as IMPORT_LIMIT } from 'model/limit';
import { IMPORT as IMPORT_PAYER_TYPE } from 'model/payerType';
import { IMPORT as IMPORT_PAYNETS } from 'model/fspPaynet';
import { IMPORT as IMPORT_RTN } from 'model/rtn';
import { IMPORT as IMPORT_SSO_URI } from 'model/ssoUri';
import { IMPORT as IMPORT_USER_ROLES } from 'model/userRole';
import { UPDATE as UPDATE_FSP } from 'model/fsp';
import { UPDATE as UPDATE_FSP_CORE_CONFIG } from 'model/fspCoreConfig';
import { UPDATE as UPDATE_FSP_CONFIG_VALUES } from 'model/fspConfigValues';
import { UPDATE as UPDATE_OTP_EVENT } from 'model/oneTimePasscodeEventConfig';
import { CREATE, CREATE_PAL_CONFIG } from 'model/fspConfigPayALoan';
import { useSelector } from 'react-redux';
import { error as selector } from 'selectors/request';
import {
  PAL_DUPLICATE_SUBDOMAIN_EXISTS_REASON,
  PAL_DUPLICATE_SUBDOMAIN_IN_PAYLOAD_REASON,
} from 'sdk/fspConfigPayALoan';
import { PAYER_TYPES } from '../../consts';

const importLimitSelector = (state) => selector(state, IMPORT_LIMIT);
const importPayerTypeSelector = (state) => selector(state, IMPORT_PAYER_TYPE);
const importPaynetsSelector = (state) => selector(state, IMPORT_PAYNETS);
const importRtnSelector = (state) => selector(state, IMPORT_RTN);
const importSSOURISelector = (state) => selector(state, IMPORT_SSO_URI);
const importUserRolesSelector = (state) => selector(state, IMPORT_USER_ROLES);
const updateFSPCoreConfigSelector = (state) =>
  selector(state, UPDATE_FSP_CORE_CONFIG);
const updateFSPSelector = (state) => selector(state, UPDATE_FSP);
const updateFSPConfigValuesSelector = (state) =>
  selector(state, UPDATE_FSP_CONFIG_VALUES);
const updateOTPEventSelector = (state) => selector(state, UPDATE_OTP_EVENT);
const createPalImportErrorSelector = (state) => selector(state, CREATE);
const createPalConfigErrorSelector = (state) =>
  selector(state, CREATE_PAL_CONFIG);

const toPalImportError = (error = {}) => {
  const reason = error?.reason;

  if (
    reason === PAL_DUPLICATE_SUBDOMAIN_IN_PAYLOAD_REASON ||
    reason === PAL_DUPLICATE_SUBDOMAIN_EXISTS_REASON
  ) {
    return {
      ...error,
      message:
        'Pay a Loan import failed: Guest URL subdomain must be unique. Update the subdomain and retry import.',
    };
  }

  return error;
};

const useFSPImportErrors = () => {
  const importLimitError = useSelector(importLimitSelector);
  const importPayerTypeError = useSelector(importPayerTypeSelector);
  const importPaynetsError = useSelector(importPaynetsSelector);
  const importRtnError = useSelector(importRtnSelector);
  const importSSOURIError = useSelector(importSSOURISelector);
  const importUserRolesError = useSelector(importUserRolesSelector);
  const updateFSPCoreConfigError = useSelector(updateFSPCoreConfigSelector);
  const updateFSPError = useSelector(updateFSPSelector);
  const updateFSPConfigValuesError = useSelector(updateFSPConfigValuesSelector);
  const updateOTPEventError = useSelector(updateOTPEventSelector);
  const createPalImportError = useSelector(createPalImportErrorSelector);
  const createPalConfigError = useSelector(createPalConfigErrorSelector);
  const createPalError = createPalImportError || createPalConfigError;

  const errors = [];

  if (importLimitError) errors.push({ key: LIMITS, error: importLimitError });
  if (importPayerTypeError)
    errors.push({ key: PAYER_TYPES, error: importPayerTypeError });
  if (importPaynetsError)
    errors.push({ key: PAYNETS_LABEL, error: importPaynetsError });
  if (importRtnError)
    errors.push({ key: ROUTING_NUMBERS_LABEL, error: importRtnError });
  if (importSSOURIError)
    errors.push({ key: SSO_URI_LABEL, error: importSSOURIError });
  if (importUserRolesError)
    errors.push({ key: USER_ROLES, error: importUserRolesError });
  if (updateFSPCoreConfigError)
    errors.push({
      key: FSP_CORE_CONFIG_LABEL,
      error: updateFSPCoreConfigError,
    });
  if (updateFSPError) errors.push({ key: FSP_LABEL, error: updateFSPError });
  if (updateFSPConfigValuesError)
    errors.push({
      key: FSP_CONFIG_VALUES_LABEL,
      error: updateFSPConfigValuesError,
    });
  if (updateOTPEventError)
    errors.push({ key: OTP_EVENT_LABEL, error: updateOTPEventError });
  if (createPalError)
    errors.push({
      key: FSP_CONFIG_PAY_A_LOAN_LABEL,
      error: toPalImportError(createPalError),
    });

  return errors;
};

export default useFSPImportErrors;
